export type FindingPublication = {
  isPublished?: boolean | null;
};

type IdsSelection = {
  mode: 'ids';
  ids: ReadonlySet<string>;
};

type FilterSelection = {
  mode: 'filter';
  filter: { isPublished?: boolean };
  excludedIds: ReadonlySet<string>;
};

export type ReportSelectionForUnpublishedCheck = IdsSelection | FilterSelection;

export type LoadedFindingPublication = FindingPublication & { id: string };

export function selectionIncludesUnpublishedFindings({
  selection,
  loadedFindingsById,
  rowFinding,
}: {
  selection: ReportSelectionForUnpublishedCheck;
  loadedFindingsById: ReadonlyMap<string, FindingPublication>;
  rowFinding?: FindingPublication;
}): boolean {
  if (rowFinding !== undefined) {
    return !rowFinding.isPublished;
  }

  if (selection.mode === 'filter') {
    if (selection.filter.isPublished === true) {
      return false;
    }

    if (selection.filter.isPublished === false) {
      return true;
    }

    for (const [id, finding] of loadedFindingsById) {
      if (selection.excludedIds.has(id)) continue;
      if (!finding.isPublished) return true;
    }

    return false;
  }

  return Array.from(selection.ids).some((id) => {
    const finding = loadedFindingsById.get(id);

    return Boolean(finding && !finding.isPublished);
  });
}

export function collectLoadedFindingsById(
  findings: readonly LoadedFindingPublication[],
): Map<string, FindingPublication> {
  return new Map(
    findings
      .filter((finding) => finding.id)
      .map((finding) => [finding.id, { isPublished: finding.isPublished }]),
  );
}
